import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import DeleteGatewayPricingPlanFormModal from 'src/features/gateway/components/form/DeleteGatewayPricingPlanFormModal';
import UpdateGatewayPricingPlanFormModal from 'src/features/gateway/components/form/UpdateGatewayPricingPlanFormModal';
import { pricingPlanMessages } from 'src/features/pricingPlan/utils/messages';
import { GatewayPricingPlan } from 'src/features/gateway/utils/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellGatewayPricingPlanActions({ row }: CellContext<GatewayPricingPlan, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateGatewayPricingPlanFormModal
                        selectedGatewayPricingPlan={row.original}
                        semantics={{ entryName: formatMessage(pricingPlanMessages.pricingPlan).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateGatewayPricingPlanFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteGatewayPricingPlanFormModal
                        selectedGatewayPricingPlan={row.original}
                        semantics={{ entryName: formatMessage(pricingPlanMessages.pricingPlan).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteGatewayPricingPlanFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
